/* eslint-disable import/prefer-default-export,import/extensions */
export { default as authDuck } from './authDuck.js';
export { default as dealsDuck } from './dealsDuck.js';
export { default as inventoryDuck } from './inventoryDuck.js';
export { default as savedInventoryDuck } from './savedInventoryDuck.js';
export { default as userDuck } from './userDuck.js';
export { default as ownersDuck } from './ownersDuck.js';
export { default as paymentsDuck } from './paymentsDuck.js';
export { default as recentSearchDuck } from './recentSearchDuck.js';
